<div
  class="login-dark"
  [style.background-image]="'url(' + backgroundImage + ')'"
>
  <div
    class="login-container flashy-card cyber-panel"
    [ngClass]="{ 'select-plan': isSelectPlanLayout }"
    role="main"
    aria-labelledby="sn-login-title"
  >
    <div class="logo-and-title text-center">
      <img
        src="assets/images/ScanNinjaHorizontal.png"
        alt="Scan Ninja"
        class="img-fluid sn-logo"
      />
      <h1 id="sn-login-title" class="sr-only">Sign in to Scan Ninja</h1>
    </div>

    <div class="illustration" aria-hidden="true">
      <div class="lock-orb" aria-hidden="true">
        <!-- decorative lock SVG inside orb -->
        <svg
          class="lock-svg"
          viewBox="0 0 64 64"
          role="img"
          aria-hidden="true"
          focusable="false"
        >
          <title>Locked</title>
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <!-- shackle -->
            <path d="M20 30 V22a12 12 0 0 1 24 0v8" />
            <!-- body -->
            <rect x="12" y="30" width="40" height="26" rx="4" ry="4" />
            <!-- keyhole -->
            <circle cx="32" cy="44" r="3.2" fill="currentColor" stroke="none" />
            <path d="M32 47 v3" stroke="currentColor" stroke-width="1.8" />
          </g>
        </svg>
      </div>
    </div>

    <div class="form-area">
      <router-outlet></router-outlet>
    </div>

    <footer class="footer text-center mt-4" aria-label="product and version">
      <p>
        A
        <a href="http://scanninja.ai" target="_blank" rel="noopener noreferrer">
          Scan Ninja Inc.
        </a>
        product
      </p>
      <p class="version">version {{ version }}</p>
    </footer>
  </div>

  @if (spinnerShow) {
    <app-loader></app-loader>
  }
</div>
